import { useMediaQuery } from "react-responsive"

export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({
        query: "(max-width:576px)",
    })

    return <>{isMobile && children}</>
}

export const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({
        query: "(min-width:577px) and (max-width:1023px)",
    })

    return <>{isTablet && children}</>
}

export const Notebook = ({ children }) => {
    const isNotebook = useMediaQuery({
        query: "(min-width:1024px) and (max-width:1440px)",
    })

    return <>{isNotebook && children}</>
}

export const PC = ({ children }) => {
    const isPc = useMediaQuery({
        query: "(min-width: 1441px)",
    })

    return <>{isPc && children}</>
}
